module.exports = __webpack_public_path__ + "img/Bouton_Feu.f6ef032c.png";